module.exports = __webpack_public_path__ + "static/pakmaya-sm-ab0099b4507dc015d83a42ac63c33d09.jpg";